import React from 'react';
import styles from './CandidatesTableProgressBar.css';

const CandidatesTableProgressBar = (props) => {

    const TOTAL_STEPS = 7;
    const progressBar = [];

    for(let i = 0; i < TOTAL_STEPS; i++){
        progressBar.push(<div key={i} className={i >= props.candidate.step ? 'emptyStyle' : 'completeStyle'}></div>);
    }

    return(
        <>
            <div className="progressBarContainer">
                {progressBar}
            </div>
            <div>{props.candidate.step}/{TOTAL_STEPS}</div>
        </>
    );
  };

export default CandidatesTableProgressBar;